<template>
    <div
        class="vehicle-visitors-filters d-flex flex-column flex-md-row justify-content-start justify-content-md-start align-items-stretch align-items-md-end"
    >
        <app-form-text-input
            label="Placa"
            v-model="filter.plate"
            class="ml-2"
            @change="updateFilters"
        />
        <app-form-select-input
            label="Tipo Vehículo"
            v-model="filter.vehicleTypeId"
            :options="vehicleTypes"
            classes="ml-2"
            @change="updateFilters"
        />

        <app-auto-complete
            label="Destino"
            v-model="destination"
            classes="filter-field"
            @change="updateFilters"
            type="structures"
            id="destination"
            :client-id="theClientId"
        />

        <app-date-picker
            label="Desde"
            v-model="filter.from"
            :with-time="false"
            classes="filter-field"
            @change="updateFilters"
            id="from"
        />
        <app-date-picker
            label="Hasta"
            v-model="filter.to"
            :with-time="false"
            classes="filter-field"
            @change="updateFilters"
            id="to"
        />
        <app-form-select-input
            :options="internalOptions"
            label="Interno / Visitante"
            v-model="filter.internal"
            classes="ml-2"
            @change="updateFilters"
        />
        <app-form-select-input
            :options="validVehicleEntryTypes"
            label="Tipo de Visitante"
            v-model="filter.vehicleEntryTypeId"
            @change="updateFilters"
            classes="ml-2"
        />
        <button class="btn btn-primary filter-field" @click="onFilter">
            <i class="fa fa-filter"></i> Filtrar
        </button>
        <button class="btn btn-secondary filter-field" @click="clearFilters">
            <i class="fa fa-trash-o"></i> Limpiar
        </button>
    </div>
</template>
<script>
import FormTextInput from '../../../UI/Controls/Forms/FormTextInput.vue'
import FormSelectInput from '../../../UI/Controls/Forms/FormSelectInput.vue'
import vehiclesRepository from '../../../../repositories/vehicles.repository'
import vigilanceRepository from '../../../../repositories/vigilance.repository'
import DatePicker from '../../../UI/Controls/DateTimePicker/DateTimePicker.vue'
import AutoComplete from '../../../UI/Controls/Autocomplete/Autocomplete.vue'
export default {
    components: {
        appFormTextInput: FormTextInput,
        appFormSelectInput: FormSelectInput,
        appDatePicker: DatePicker,
        appAutoComplete: AutoComplete,
    },
    props: {
        onFilter: {
            type: Function,
            required: true,
        },
        clientId: {
            type: Number,
        },
    },
    data() {
        return {
            filter: {
                plate: '',
                vehicleTypeId: '',
                from: '',
                to: '',
                destinationId: '',
                internal: '',
                vehicleEntryTypeId: '',
            },
            vehicleTypes: [],
            vehicleEntryTypes: [],
            destination: '',
            internalOptions: [
                { id: '1', name: 'Interno' },
                { id: '0', name: 'Externo' },
            ],
        }
    },
    watch: {
        destination(newValue, oldValue) {
            !!newValue && (this.filter.destinationId = newValue.id)
        },
    },
    methods: {
        loadVehicleEntryTypes() {
            const vr = Object.assign({}, vigilanceRepository)
            vr.getVehicleEntryTypes()
                .then(data => (this.vehicleEntryTypes = data))
                .catch(error =>
                    toastr.error(
                        'Ocurrió un error al cargar los tipos de visitante'
                    )
                )
        },
        loadVehicleTypes() {
            const vr = Object.assign({}, vehiclesRepository)
            vr.getTypes()
                .then(data => (this.vehicleTypes = data))
                .catch(error =>
                    toastr.error('Error al cargar los tipos de vehículo')
                )
        },
        updateFilters() {
            this.$emit('input', this.filter)
        },
        clearFilters() {
            Object.keys(this.filter).map(key => (this.filter[key] = ''))
            this.$bus.$emit('from.clear')
            this.$bus.$emit('to.clear')
            this.$bus.$emit('destination.reset')
            this.$emit('change', this.filter)
            this.onFilter()
        },
    },
    computed: {
        validVehicleEntryTypes() {
            if (!this.vehicleEntryTypes) return []
            return this.vehicleEntryTypes
        },
        theClientId() {
            return ['super_admin', 'administrador', 'administrativo'].includes(
                this.user.profile.slug
            )
                ? this.clientId
                : this.client.id
        },
    },
    created() {
        this.loadVehicleTypes()
        this.loadVehicleEntryTypes()
    },
}
</script>
